import React from "react";
import { IonContent, IonRow, IonCol, IonPage } from '@ionic/react';
import './UpgradePage.scss';
import { baseUrl, cacheBust } from "../helpers/configHelper";
import { formatCurrency } from "../helpers/currencyHelpers";
import { useSelector } from "react-redux";
import { ApplicationState } from "../store";
import { DealItem } from "../store/MenuStoreTypes";
import { inlineBrandImage } from "../helpers/menuHelpers";

interface IMenuItemRowProps {
    itemSku: string;
    itemName: string;
    itemPrice: number;
    hasBrandImage: boolean;
}

function MenuItemRow(props: IMenuItemRowProps) {
    return (
        <IonRow>
            <IonCol size="4">
                <img
                    src={`${baseUrl()}/images/ProductShots/${props.itemSku}_PLP.png?v=${cacheBust()}`}
                    alt=""
                />
            </IonCol>
            <IonCol className='item-details'>
                <p className="item-name" dangerouslySetInnerHTML={{__html: inlineBrandImage(props.itemName, props.hasBrandImage)}} />
                <p className="item-price">{formatCurrency(props.itemPrice)}</p>
            </IonCol>
        </IonRow>
    )
}

function getImageSrc(imageUrl: string, size: number) {
    return `${baseUrl()}/images/Deals/${size}/${imageUrl.replace('deal', 'upgrade')}?v=${cacheBust()}`
}

function UpgradePage() {
    const deal = useSelector((state: ApplicationState) => {
        if (!state.deal?.deals) {
            console.error("Upgrade: No deals found");
            return;
        }

        const deals = state.deal.deals;

        if (!state.deal?.currentDealSku) {
            console.error("Upgrade: No current deal sku");
            return;
        }

        const currentDealSku = state.deal.currentDealSku;

        return deals.find((v: DealItem) => {
            return v.dealSku === currentDealSku
        });
    });

    const menuItem = useSelector((state: ApplicationState) => {
        if (!state.menuItemData?.menuItem) {
            console.error("Deals: No menu item data");
            return;
        }

        const menuItem = state.menuItemData.menuItem;

        if (!state.deal?.upgradedFromSku) {
            console.error("Deals: No current menu item sku.");
            return;
        }

        return menuItem;
    });

    return (
        <IonPage>
            <IonContent fullscreen className="upgrade-page">
                <div className='banner'>
                    {deal?.dealSku === '0DEAL202414'
                        ? <p>Make me a deal?</p>
                        : <p>Want to upgrade?</p>
                    }
                </div>
                <div className="container">
                    {menuItem &&
                        <MenuItemRow
                            itemSku={menuItem.sku}
                            itemName={menuItem.menuItemName}
                            itemPrice={menuItem.menuItemFromPrice
                                ? menuItem.menuItemFromPrice
                                : menuItem.menuItemBasePrice}
                            hasBrandImage={menuItem.hasBrandImage}
                        />

                    }
                    {deal &&
                        <img
                            alt=""
                            srcSet={`
                                ${getImageSrc(deal.imageUrl, 600)} 600w,
                                ${getImageSrc(deal.imageUrl, 450)} 450w,
                                ${getImageSrc(deal.imageUrl, 300)} 300w,
                            `}
                            sizes='(min-width: 450px) 600px, (min-width: 300px) 450px, 300px'
                        />
                    }
                </div>
            </IonContent>
        </IonPage>
    );
}

export default UpgradePage;
